<template>
    <span>
        {{ number ? Math.ceil(number).toLocaleString() : '-' }}
    </span>
</template>

<script>
export default {
    name: "Number",
    props: {
        number: {
            type: Number,
            default: null,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/common/Number.vue